export default __webpack_public_path__ + "static/media/Caravan Mannen utan spår_ljudläggare_mixare.c18afca2.jpeg";